import React, { Component } from "react";
import Progress from "../../common/Progress";
import { Redirect } from "react-router-dom";
import { NavLink } from "react-router-dom";
import copy from "../../assets/copy.svg";
import BackArrow from "../../common/BackArrow";
import { connect } from "react-redux";

const mapStateToProps = (state) => ({
  userProfile: state.userProfile,
});

export default connect(mapStateToProps)(
  class Onboarding extends Component {
    state = {
      link: (
        <>
          {String.capitalize(this.props.userProfile.first_name)} is inviting you
          to their Kindlybook Business account. Kindlybook helps you manage bookings
          easily!
          <br />
          <br />
          Use this link to register{" "}
          <span className="link">
            {window.location.hostname === "localhost" ? "http" : "https"}://
            {window.location.host}/business/signup?invite_code=
            {this.props.match.params.business_invite_code}
          </span>
        </>
      ),
      code: this.props.match.params.business_invite_code,
      raw_link: `${
        window.location.hostname === "localhost" ? "http" : "https"
      }://${window.location.host}/business/signup?invite_code=${
        this.props.match.params.business_invite_code
      }`,
    };
    link = React.createRef();


    componentDidMount = () => {
      //code zero means go back to booking settings...
      if (this.props.match.params.business_invite_code == 0) {
        this.setState({redirect : "/"})
      }
    };



    render() {
      const link_message = `${String.capitalize(
        this.props.userProfile.first_name
      )} is inviting you to their Kindlybook Business account 🗃. \nKindlybook helps you manage bookings easily! Use this link to register \n \n${
        this.state.raw_link
      }`;

      return (
        <div className="onboarding-page">
          {this.state.redirect ? <Redirect to={this.state.redirect} /> : ""}

          <Progress total={5} current={5}>
            <div className="form-title dsk">
              Invite team members
              <p>
                Optional – Share your invite code or with link with team members
                to add them to your Kindlybook business account.
              </p>
            </div>
          </Progress>

          <div className="form_step form-page">
            <div className="form-title mbl">
              <span className="flex center form-title" style={{ padding: 0 }}>
                <BackArrow />
                Invite team members
              </span>
              <p>
                Optional – Share your invite code or with link with team members
                to add them to your Kindlybook business account.
              </p>
            </div>
            <div className="form-container card">
              {/* <div className="input-rapper">
              <p className="label">Your invite code</p>
              <div className="field colored">gentlemencuts1234</div>
            </div> */}
              <div className="input-rapper">
                <p className="label">Your invite code</p>
                <div className="field co-black w-900">
                  {this.state.code}
                  <div className="footer">
                    <button
                      className="co-pink copy-btn"
                      data-clipboard-text={this.state.code}
                      onClick={window.copiedLink}
                    >
                      <img src={copy} alt="" srcSet="" /> Copy Code
                    </button>
                  </div>
                </div>
              </div>
              <div className="input-rapper">
                <p className="label">Copy your invite link and message</p>
                <div className="field" ref={this.link}>
                  {this.state.link}
                  <div className="footer">
                    <button
                      className="co-pink copy-btn"
                      data-clipboard-text={link_message}
                      onClick={window.copiedLink}
                    >
                      <img src={copy} alt="" srcSet="" /> Copy Link
                    </button>
                  </div>
                </div>
              </div>

              <div className="flex center space-btw">
                <NavLink className="left-btn" to={{ pathname: "/" }}>
                  I'll do this later
                </NavLink>
                <button
                  className="default"
                  onClick={() => this.setState({ redirect: "/" })}
                >
                  Finish
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
);
